<template>
  <div id="totalBox">
    <div class="bannerBox">
      <img src="../../assets/home/ckBanner.jpg" class="bannerImg"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Ckbanner',
  data: function () {
    return {
      msg: '1'
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
  height: 660px;
  background-color: rgba(61,59,79,1);
}
.bannerBox{
  width: 1200px;
  height: 660px;
  margin: 0 auto;
}
.bannerImg{
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ck/ckbanner.vue